exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animate__fade-in__38FRS,.animate__fade-in-out__2L0Lh{position:relative;height:inherit;opacity:0;visibility:hidden;transition:opacity .3s ease-in-out;max-width:0;max-height:0;overflow:hidden}.animate__fade-in-out__2L0Lh.animate__active__3j9wN,.animate__fade-in__38FRS.animate__active__3j9wN{max-width:none;max-height:none;opacity:1;visibility:visible}.animate__fade-in-out__2L0Lh{transition:visibility 0s .3s,opacity .3s;transition-timing-function:ease-in-out}.animate__fade-in-out__2L0Lh.animate__active__3j9wN{transition-delay:0s}", ""]);

// exports
exports.locals = {
	"fade-in": "animate__fade-in__38FRS",
	"fadeIn": "animate__fade-in__38FRS",
	"fade-in-out": "animate__fade-in-out__2L0Lh",
	"fadeInOut": "animate__fade-in-out__2L0Lh",
	"active": "animate__active__3j9wN"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/views/desktop/compact/components/animate/animate.styl
// module id = 1645
// module chunks = 1 2 3